import { ReferenceDot } from "recharts";
import { ChartWithBenchmarkType } from "../../../types/chart";
import { SmardEndDot } from "../dots/end-dots";

export function displayChartSmardEndDot(
  data: ChartWithBenchmarkType[],
  isEndDotsShown: boolean
): JSX.Element {
  return (
    <ReferenceDot
      yAxisId="left"
      x={data[data.length - 1].timestamp}
      y={data[data.length - 1].amount}
      shape={<SmardEndDot isEndDotsShown={isEndDotsShown} />}
    />
  );
}

export function displayCoinChartSmardEndDot(
  data: ChartWithBenchmarkType[],
  isEndDotsShown: boolean
): JSX.Element {
  return (
    <ReferenceDot
      yAxisId="right"
      x={data[data.length - 1].timestamp}
      y={data[data.length - 1].amount}
      shape={<SmardEndDot isEndDotsShown={isEndDotsShown} />}
    />
  );
}
